const customSelect = Array.from(document.querySelectorAll('[data-trigger]'));

customSelect.map(select => {
	new Choices(select, {
		placeholderValue: 'This is a placeholder set in the config',
		searchPlaceholderValue: 'This is a search placeholder'
	});
});

const customSelectIcon = Array.from(document.querySelectorAll('[data-trigger-icon]'));

customSelectIcon.map(select => {
	new Choices(select, {
		placeholderValue: 'This is a placeholder set in the config',
		searchPlaceholderValue: 'This is a search placeholder',
		searchEnabled: false,
    removeItemButton: true,
    itemSelectText: '',
		callbackOnCreateTemplates: function(strToEl) {
      var classNames = this.config.classNames;
      var itemSelectText = this.config.itemSelectText;
      return {
        item: function(classNames, data) {
          return strToEl(
            '\
        <div\
          class="' +
              String(classNames.item) +
              ' ' +
              String(
                data.highlighted
                  ? classNames.highlightedState
                  : classNames.itemSelectable
              ) +
              '"\
          data-item\
          data-id="' +
              String(data.id) +
              '"\
          data-value="' +
              String(data.value) +
              '"\
          ' +
              String(data.active ? 'aria-selected="true"' : '') +
              '\
          ' +
              String(data.disabled ? 'aria-disabled="true"' : '') +
              '\
          >\
          <span>' + select.getAttribute('data-icon') + '</span> ' +
              String(data.label) +
              '\
        </div>\
      '
          );
        },
        choice: function(classNames, data) {
          return strToEl(
            '\
        <div\
          class="' +
              String(classNames.item) +
              ' ' +
              String(classNames.itemChoice) +
              ' ' +
              String(
                data.disabled
                  ? classNames.itemDisabled
                  : classNames.itemSelectable
              ) +
              '"\
          data-select-text="' +
              String(itemSelectText) +
              '"\
          data-choice \
          ' +
              String(
                data.disabled
                  ? 'data-choice-disabled aria-disabled="true"'
                  : 'data-choice-selectable'
              ) +
              '\
          data-id="' +
              String(data.id) +
              '"\
          data-value="' +
              String(data.value) +
              '"\
          ' +
              String(
                data.groupId > 0 ? 'role="treeitem"' : 'role="option"'
              ) +
              '\
          >\
          <span>' + select.getAttribute('data-icon') + '</span> ' +
              String(data.label) +
              '\
        </div>\
      '
          );
        },
      };
    },
	});
});